import routerOptions0 from "/home/forge/stage.efxpp.ch/node_modules/nuxt/dist/pages/runtime/router.options";
import routerOptions1 from "/home/forge/stage.efxpp.ch/app/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}